import styled from 'styled-components';

interface HeaderButtonWrapperProps {
  $isOpen?: boolean;
}

// eslint-disable-next-line eag/no-css-property -- Muted pre-existing violation
export const HeaderButtonWrapper = styled.div<HeaderButtonWrapperProps>`
  position: relative;
  & > button[aria-label*='topBar'] {
    background-color: ${({theme, $isOpen}) => $isOpen && theme.colors.palettes.neutral[30][100]};
  }
`;
